module.exports = __webpack_public_path__ + "img/selected5-min.1af3d109.png";